import { createSelector } from 'reselect';
import { moduleName } from '../constants';

const getConfigState = (state) => state.get('config');
const getBrowserState = (state) => state.get('browser');
const getModuleState = (state) => state.getIn(['modules', moduleName]);
const getLocaleFilename = createSelector(
  [getConfigState],
  (config) => config.get('localeFilename')
);
const getEligibilitiesState = createSelector(
  [getModuleState],
  (moduleState) => moduleState.get('eligibilities')
);

const getConfigDetails = createSelector(
  [getConfigState],
  (config) => ({
    docUploadApiResource: config.get('imageViewerDocUploadApiUrl'),
    faasApiResource: config.get('faasApiUrl'),
    graphqlApiResource: config.get('graphApiUrl'),
    localeFilename: config.get('localeFilename'),
    oneIdentity: config.get('oneIdentityTenantUrl'),
  })
);

const getBrowserDetails = createSelector(
  [getBrowserState],
  (browser) => ({
    blueboxpublic: browser.getIn(['cookies', 'blueboxpublic']),
    originLocation: browser.getIn(['location', 'origin']),
  })
);

const getMetricsUrl = createSelector(
  [getLocaleFilename],
  (localeFilename) => {
    switch (localeFilename) {
      case 'integration': // e1
        return 'https://cdaas-dev.americanexpress.com/cdaas/ali/lib/ali-metrics.js';
      case 'qa': // e2
        return 'https://cdaas-test.americanexpress.com/cdaas/ali/lib/ali-metrics.js';
      default: // e3
        return 'https://www.aexp-static.com/cdaas/akamai/ali/lib/ali-metrics.js';
    }
  }
);

const getStylingDetails = createSelector(
  getEligibilitiesState,
  (eligibilitiesState) => ({
    isDls7Enabled: eligibilitiesState.get('dls7Enabled'),
    isDls7Eligible: eligibilitiesState.get('dls7Eligible'),
    isVortexEnabled: eligibilitiesState.get('vortexEnabled', false),
  })
);

export {
  getConfigDetails,
  getBrowserDetails,
  getMetricsUrl,
  getStylingDetails,
};
